import React from 'react';
import classNames from 'classnames';
import Button from '@material-ui/core/Button';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@material-ui/icons/Close';
import green from '@material-ui/core/colors/green';
import amber from '@material-ui/core/colors/amber';
import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import WarningIcon from '@material-ui/icons/Warning';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { WithStyles, createStyles } from '@material-ui/core';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';


import serverAlertActions from './actions/serverAlertActions';
import { ServerAlertDataV2, VARIANT } from './types/ServerAlertDataV2';

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
  loginSuccess: CheckCircleIcon,
  loginError: ErrorIcon,
};

const styles1 = (theme: Theme) => createStyles({
  success: {
    '&::after': {
      backgroundColor: '#21A67A',
    },
  },
  error: {
    backgroundColor: theme.palette.error.dark,
  },
  info: {
    backgroundColor: theme.palette.primary.dark,
  },
  warning: {
    backgroundColor: amber[700],
  },
  iconVariant: {
    color: '#f44335',
    marginRight: theme.spacing.unit,
  },
  message: {
    display: 'flex',
    alignItems: 'center',
    color: '#333333',
    fontSize: 16,
    lineHeight: '20px',
    fontWeight: 700,
    padding:"10px 0",
  },
  loginSuccess: {
    '&::after': {
      backgroundColor: '#21A67A',
    },
  },
  loginError: {
    '&::after': {
      backgroundColor: '#f44335',
    },
  },
  icon: {
    width: 18,
  },
  close: {
    width: 22,
    height: 22,
    borderRadius: 22,
    backgroundColor: '#F5F5F5',
    justifyContent: 'center',
    color: '#666'
  },
  root: {
    '&:hover': {
      backgroundColor: 'none',
    }
  },
  toaster:{
    '&::after': {
      content: '""',
      minHeight: 50,
      position: 'absolute',
      width: 5,
      borderRadius: 20,
      left: 15,
      height:"65%"
    },
    backgroundColor: '#ffffff',
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#E7E7E7',
    borderRadius: 8
  },
  toasterContent:{
    maxWidth:"400px",
    width:"fit-content"
  },
  toasterWidth:{
    minWidth:"280px"
  }
});

//@ts-ignore
interface MySnackbarContentV2 extends WithStyles<typeof styles1> {
  classes: any,
  className: string,
  message: any,
  onClose: Function,
  variant: VARIANT ,
  title?:string
}


function MySnackbarContentV2(props: MySnackbarContentV2) {
  const { classes, className, message, onClose, variant,title, ...other } = props;
  const Icon = variantIcon[variant];

  const getVariantImage=()=>{
    return variant === VARIANT.LOGIN_SUCCESS || variant === VARIANT.SUCCESS ?  '/assets/img/singleSignin/success.svg':'/assets/img/singleSignin/cross.svg';
  }

  const getBodyForToaster = () => {
    const toasterTitle = title || message;
    const toasterMessage = title && message

    return (
      <div className="toster-inner">
        <div className={classNames("toster-content", classes.toasterWidth)}>
          <b>{toasterTitle}</b>
          {toasterMessage && <span className={classes.toasterContent} >{toasterMessage}</span>}
        </div>
      </div>)
  }

  return (
    <SnackbarContent
      className={classNames(classes.toaster,classes[variant], className)}
      aria-describedby="client-snackbar"
      message={
        <span id="client-snackbar" className={classes.message}>
          <img style={{marginLeft: '10px'}} src={getVariantImage() } alt="show password" />
          {/* <Icon className={classNames(classes.icon, classes.iconVariant)} /> */}
          {getBodyForToaster()}
        </span>
      }
      action={[
        <IconButton
          //@ts-ignore
          key="close"
          aria-label="Close"
          color="inherit"
          className={classes.close}
          onClick={() => { onClose() }}
        >
          <CloseIcon className={classes.icon} />
        </IconButton>,
      ]}
      {...other}
    />
  );
}

//@ts-ignore
const MySnackbarContentWrapperV2 = withStyles(styles1)(MySnackbarContentV2);






const styles2 = (theme: Theme) => createStyles({
  margin: {
    margin: theme.spacing.unit,
  },
});

//@ts-ignore
interface MyPATSnackbarProps extends WithStyles<typeof styles2> {
  classes: any,
  dispatch: any,
  message: any,
  variant: 'success' | 'warning' | 'error' | 'info' | 'loginSuccess' | 'loginError',
  open?: boolean,
  hideAlertV2: (id: string) => void;
  serverAlert: ServerAlertDataV2[]
}

interface MyPATSnackbarStateV2 {
  open?: boolean
}

class MyPATSnackbarV2 extends React.Component<MyPATSnackbarProps, MyPATSnackbarStateV2> {

  constructor(props: MyPATSnackbarProps, state: MyPATSnackbarStateV2) {
    super(props)

  }


  handleClick = () => {
  };

  render() {
    const { classes, serverAlert } = this.props;


    return (
      <div>
        {serverAlert.map((data, i) => {
          const { openSnackbarV2, variant, message, id,title } = data;

          return (
            <Snackbar
              key={id}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              style={{ top: `${i * 120 + 30}px` }}
              open={openSnackbarV2}
              autoHideDuration={3000}
              onClose={() => this.props.hideAlertV2(id || '')}
            >
              <MySnackbarContentWrapperV2
                onClose={() => this.props.hideAlertV2(id || '')}
                variant={variant}
                message={message}
                title={title}
              />
            </Snackbar>
          );
        })}

      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    serverAlert: state.commonData.serverAlert
  }
}

const mapDispatchToProps = (dispatch: any) => bindActionCreators(
  {
    hideAlertV2: serverAlertActions.hideAlertV2
  },
  dispatch
)

//@ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles2)(MyPATSnackbarV2));